export const FETCH_MY_EXPERT_SERVICES_REQUEST =
  "FETCH_MY_EXPERT_SERVICES_REQUEST";
export const FETCH_MY_EXPERT_SERVICES_SUCCESS =
  "FETCH_MY_EXPERT_SERVICES_SUCCESS";
export const FETCH_MY_EXPERT_SERVICES_FAIL = "FETCH_MY_EXPERT_SERVICES_FAIL";

export const FETCH_EXPERT_SERVICE_BY_ID_REQUEST =
  "FETCH_EXPERT_SERVICE_BY_ID_REQUEST";
export const FETCH_EXPERT_SERVICE_BY_ID_SUCCESS =
  "FETCH_EXPERT_SERVICE_BY_ID_SUCCESS";
export const FETCH_EXPERT_SERVICE_BY_ID_FAIL =
  "FETCH_EXPERT_SERVICE_BY_ID_FAIL";

export const CREATE_EXPERT_SERVICE_REQUEST = "CREATE_EXPERT_SERVICE_REQUEST";
export const CREATE_EXPERT_SERVICE_SUCCESS = "CREATE_EXPERT_SERVICE_SUCCESS";
export const CREATE_EXPERT_SERVICE_FAIL = "CREATE_EXPERT_SERVICE_FAIL";

export const UPDATE_EXPERT_SERVICE_REQUEST = "UPDATE_EXPERT_SERVICE_REQUEST";
export const UPDATE_EXPERT_SERVICE_SUCCESS = "UPDATE_EXPERT_SERVICE_SUCCESS";
export const UPDATE_EXPERT_SERVICE_FAIL = "UPDATE_EXPERT_SERVICE_FAIL";

export const TOGGLE_EXPERT_SERVICE_ACTIVE_REQUEST =
  "TOGGLE_EXPERT_SERVICE_ACTIVE_REQUEST";
export const TOGGLE_EXPERT_SERVICE_ACTIVE_SUCCESS =
  "TOGGLE_EXPERT_SERVICE_ACTIVE_SUCCESS";
export const TOGGLE_EXPERT_SERVICE_ACTIVE_FAIL =
  "TOGGLE_EXPERT_SERVICE_ACTIVE_FAIL";

export const DELETE_EXPERT_SERVICE_REQUEST = "DELETE_EXPERT_SERVICE_REQUEST";
export const DELETE_EXPERT_SERVICE_SUCCESS = "DELETE_EXPERT_SERVICE_SUCCESS";
export const DELETE_EXPERT_SERVICE_FAIL = "DELETE_EXPERT_SERVICE_FAIL";

export const FETCH_EXPERT_SERVICES_BY_EXPERT_REQUEST =
  "FETCH_EXPERT_SERVICES_BY_EXPERT_REQUEST";
export const FETCH_EXPERT_SERVICES_BY_EXPERT_SUCCESS =
  "FETCH_EXPERT_SERVICES_BY_EXPERT_SUCCESS";
export const FETCH_EXPERT_SERVICES_BY_EXPERT_FAIL =
  "FETCH_EXPERT_SERVICES_BY_EXPERT_FAIL";

export const RESET_EXPERT_SERVICES_ERROR = "RESET_EXPERT_SERVICES_ERROR";
